/** Operator initial-review workspace (embedded in ProjectWorkspace). */

export const OPERATOR_PAGE_SHELL_SX = {
  width: "100%",
  maxWidth: "100%",
  bgcolor: "transparent",
  p: 0,
  overflow: "hidden",
  boxSizing: "border-box",
};

export const OPERATOR_MAIN_COLUMN_SX = {
  minWidth: 0,
  width: "100%",
};

export const OPERATOR_CARD_SX = {
  borderRadius: "14px",
  bgcolor: "background.paper",
  border: "1px solid",
  borderColor: "divider",
  boxShadow: "0 4px 18px rgba(15, 23, 42, 0.06)",
  overflow: "hidden",
  width: "100%",
  minWidth: 0,
};

export const OPERATOR_HERO_HEADER_SX = {
  px: { xs: 2, md: 2.5 },
  py: 2,
  borderBottom: 1,
  borderColor: "divider",
  background: (theme) =>
    theme.palette.mode === "dark"
      ? "linear-gradient(135deg, rgba(25,118,210,0.18) 0%, rgba(76,175,80,0.1) 100%)"
      : "linear-gradient(135deg, #E3F2FD 0%, #E8F5E9 55%, #FFFDE7 100%)",
};

export const OPERATOR_SECTION_TITLE_SX = {
  fontWeight: 800,
  fontSize: "1.05rem",
  lineHeight: 1.4,
  color: "text.primary",
  mb: 1.5,
};

/** Stacked full-width review cards (fits ProjectWorkspace md=9 column). */
export const OPERATOR_QUICK_REVIEW_STACK_SX = {
  display: "flex",
  flexDirection: "column",
  gap: 2,
  width: "100%",
};

/** Field grid inside each review card. */
export const OPERATOR_QUICK_REVIEW_FIELDS_SX = {
  display: "grid",
  gridTemplateColumns: {
    xs: "1fr",
    sm: "repeat(2, minmax(220px, 1fr))",
  },
  gap: 2,
  columnGap: 3,
};

export const OPERATOR_HERO_STATS_SX = {
  display: "grid",
  gridTemplateColumns: {
    xs: "repeat(2, minmax(140px, 1fr))",
    md: "repeat(4, minmax(160px, 1fr))",
  },
  gap: 2,
  p: { xs: 2, md: 2.5 },
};

/** Loan metrics — three equal columns. */
export const OPERATOR_LOAN_STATS_SX = {
  display: "grid",
  gridTemplateColumns: {
    xs: "1fr",
    sm: "repeat(3, minmax(180px, 1fr))",
  },
  gap: 2,
};

export const OPERATOR_LOAN_STAT_BOX_SX = {
  borderRadius: 2,
  p: 2,
  bgcolor: (theme) =>
    theme.palette.mode === "dark" ? "action.hover" : "#F5F9FF",
  border: "1px solid",
  borderColor: "primary.light",
  textAlign: "center",
};

/** Documents: max 3 columns in workspace content area. */
export const OPERATOR_GALLERY_GRID_SX = {
  display: "grid",
  gridTemplateColumns: {
    xs: "repeat(2, minmax(0, 1fr))",
    sm: "repeat(3, minmax(0, 1fr))",
  },
  gap: 2,
  width: "100%",
  minWidth: 0,
};

export const OPERATOR_META_LABEL_SX = {
  fontSize: "0.8125rem",
  color: "text.secondary",
  lineHeight: 1.45,
  mb: 0.35,
};

export const OPERATOR_META_VALUE_SX = {
  fontSize: "0.9375rem",
  fontWeight: 700,
  lineHeight: 1.5,
  wordBreak: "break-word",
};

export const OPERATOR_LOAN_VALUE_SX = {
  fontSize: { xs: "1.2rem", md: "1.4rem" },
  fontWeight: 800,
  lineHeight: 1.3,
  color: "primary.main",
};

export const OPERATOR_DECISION_CARD_SX = {
  ...OPERATOR_CARD_SX,
  borderColor: "primary.light",
  borderWidth: 2,
};
